import request from '@/router/axios';
// 查询配电站列表
export function getList(param) {
    console.log(param,'--')
    return request({
        url: `/api/gateway/page`,
        method: 'get',
        params: param
    });
}
// 新增
export function addObj(param) {
    return request({
        url: `/api/gateway`,
        method: 'POST',
        data: param
    });
}
// 修改
export function editObj(param) {
    return request({
        url: `/api/gateway`,
        method: 'PUT',
        data: param
    });
}
// 设备型号列表
export function modelList(param) {
    return request({
        url: `/api/gateway/model/list`,
        method: 'get',
    });
}

// 删除
export function deleteObj(param) {
    return request({
        url: `/api/gateway/${param.id}`,
        method: 'delete'
    });
}

// 运维中心地图设备列表
export function mapList() {
    return request({
        url: `/api/statis/project/list`,
        method: 'get'
    })
}

// 运维中心右侧各地分布统计
export function distributionData() {
    return request({
        url: `/api/statis/projectDistribution`,
        method: 'get'
    })
}

// 运维中心右侧各地分布统计
export function stateData() {
    return request({
        url: `/api/statis/deviceState`,
        method: 'get'
    })
}